var exports = {
  "kL": "ColorPickerPopover.module__container___WFVlZm",
  "ij": "ColorPickerPopover.module__pickerContainer___WFVlZm",
  "mo": "ColorPickerPopover.module__pickerContainerWithMargin___WFVlZm",
  "og": "ColorPickerPopover.module__pickerWrapper___WFVlZm",
  "$n": "ColorPickerPopover.module__colorArea___WFVlZm",
  "DN": "ColorPickerPopover.module__colorSlider___WFVlZm",
  "NB": "ColorPickerPopover.module__sliderTrack___WFVlZm",
  "eo": "ColorPickerPopover.module__colorThumb___WFVlZm",
  "WA": "ColorPickerPopover.module__resetButton___WFVlZm",
  "px": "ColorPickerPopover.module__resetButtonText___WFVlZm",
};

module.exports = exports;
